import React from "react";

import Icon from "../../../../components/Icon";

const SITUATIONS = {
    received: 'Recebido',
    paid: 'Pago',
    open: 'Em aberto',
    overdue: 'Atrasado',
    transferred: 'Transferido',
};

export const getSituationLabel = situation => SITUATIONS[situation] ?? situation;

export const EntrySituationBadge = ({ situation, reconciled, partial }) => (
    <span className={`finance-situation situation-${situation}`} title={reconciled ? 'Conciliado com o extrato bancário' : undefined}>
        {getSituationLabel(situation)}
        {partial && <small> · parcial</small>}
        {reconciled && <Icon name="task-completed" size={14} />}
    </span>
);

export default EntrySituationBadge;
